const AddressMapper = {
  "Address Name": "customerName",
  City: "addressCity",
  "Line 1": "addressLine1",
  "Line 2": "addressLine2",
  "Post ID": "postId",
};

export const transformToAddressMeta = ({ data }) => {
  const output = {};
  for (const [key, transformedKey] of Object.entries(AddressMapper)) {
    output[transformedKey] =
      !data[key] || data[key] === "null" ? "" : data[key];
  }
  return output;
};
